import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-albumslist',
  templateUrl: './albumslist.component.html',
  styleUrls: ['./albumslist.component.scss']
})

export class AlbumslistComponent {
  
  public albumListing:any=[];
  public allData:any=[];
  public weekarray:any=[]
  public loading:boolean = true;
  public loginDetail:any =[];
  public showView:boolean=false;
  public currentUrl:any=this.router.url;
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any=0;
  public Program_name:any='';
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = getLocalJSON('grw_login');
    var mm:any='';
    if(this.currentUrl=='/album-video-list'){
      mm="/album-detail?album_id="+localStorage.getItem('grw_album_id');
      this.getDetail(mm);
    } else{
      mm="/program-detail?program_id="+localStorage.getItem('grw_program_id');
      this.getDetail(mm);
    }

   
   }

  ngOnInit(): void {
  }

     getDetail(type:any){
      this.service.GetApi(type).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.Program_name =response.data.name;
          if(this.currentUrl=='/album-video-list'){
            this.albumListing= response.data.album_videos;
          } else {
            var count =1,jj=1;
            response.data.program_videos.filter ((el:any)=>{
              if(count ==1){
                self.weekarray.push(el.week_id);
                count=count+1;
              } else {
                self.weekarray.filter((ell:any)=>{
                  if(ell != el.week_id){
                    jj=0;
                  } else {
                    jj=1;
                  }
                })
                if(jj==0){
                  self.weekarray.push(el.week_id);
                  jj=1;
                }
              }
            
            })
            this.albumListing= response.data.program_videos;
            this.allData = response.data.program_videos;
          }
          this.showView=true;
          this.loading=false;
        } else {
          this.albumListing=[];
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    redirect(item:any){
      localStorage.setItem('grw_content_id',item._id);
      this.router.navigate(['/video-detail']);
    }

    getRecord(type:any){
      var self =this;
      if(type == ''){
        this.albumListing = this.allData;
      } else {
        this.albumListing =[];
        this.allData.filter((el:any)=>{
          if(el.week_id == type){
            self.albumListing.push(el);
          }
        })
      }

    }


}
